import { buildFilterMapping } from '@/components/AgGrid/helpers/filterHelpers';

const filterMappingByColumnType = [
  {
    string: { filter: 'agTextColumnFilter' },
  },
  {
    number: { filter: 'agNumberColumnFilter' },
  },
  {
    integer: { filter: 'agNumberColumnFilter' },
  },
  {
    date: { filter: 'customDateFilter' },
  },
  {
    boolean: { filter: 'agSetColumnFilter' },
  },
  {
    select: { filter: 'agSetColumnFilter' },
  },
];

export const filterMapping = buildFilterMapping(filterMappingByColumnType);
